export const AffixSortingValues =
{
  " To Dexterity" : 50,
  " To Strength" : 50,
  " To Intelligence" : 50,
  " To Accuracy Rating" : 51,
  "% Increased Accuracy Rating" : 52,
  " To Maximum Life" : 53,
  " Life Regenerated Per Second" : 54,
  " To Maximum Mana" : 55,
  "% Increased Evasion Rating" : 56,
  "% Increased Armor Rating" : 57,
  "% Increased Energy Shield" : 58,
  " To Evasion Rating" : 59,
  " To Armor Rating" : 60,
  " To Energy Shield" : 61,
  "% Increased Rarity of Items Found" : 62,
  "% To Fire Resistance" : 63,
  "% To Cold Resistance" : 64,
  "% To Lightning Resistance" : 65,
  "% To Chaos Resistance" : 66,
  "% Increased Stun And Block Recovery" : 67,
  "% Reduced Attribute Requirements" : 68,
  " Physical Damage To Melee Attackers" : 69,
  "% Increased Light Radius" : 70,
  "% Chance To Dodge Attacks" : 71
};



// WEBPACK FOOTER //
// ./src/js/affix-sorting-values.js